<template>
  <div class="">
    <div class="print-style">

      <!-- --kiosk-printing   -->

      <b-col class="d-print-none mb-3 mt-3">


        <b-container>
          <b-icon-printer @click="print()" class="h1 custom-pointer-print-icon"/>
        </b-container>


      </b-col>

      <div class="text-center">
        <h3 class="base-font-size">صورت حساب</h3>
      </div>


      <b-col v-if="sidebarData.address !== null && sidebarData.address !== undefined" lg="12" class="mt-3">
        <b-card class="list">

          <b-row>
            <b-col lg="6">
              <p class="">
                شماره سفارش:
                {{ sidebarData.id }}
              </p>


              <p>
                <b> گیرنده:</b>
                {{ sidebarData.user.name }} {{ sidebarData.user.last_name }}
              </p>

            </b-col>

            <b-col lg="6">

              <p dir="ltr">
                {{ dateConverter(sidebarData.created_at, '/', true) }}
              </p>

              <p>
                <b>شماره تماس:</b>
                {{ sidebarData.user.cellphone }}
              </p>

            </b-col>

            <b-col lg="12">

              <p>
                <b>توضیحات سفارش:</b>
                {{ sidebarData.description }}
              </p>

              <p>
                <b>آدرس: </b>
                <span v-if="sidebarData.address.default_address == 0">
                  {{ sidebarData.address.address }}
                  </span>
                <span v-else>{{ sidebarData.address.address }}</span>
                <span v-if=" sidebarData.address.description ">
                  ({{ sidebarData.address.description }})
                </span>
              </p>
            </b-col>

          </b-row>


        </b-card>
      </b-col>

      <table-paid-items class="p-0 m-0" :items="items"/>

      <table class="text-center p-0 m-0 table">
        <thead>
        <tr>
          <th>مبلغ اصلی</th>
          <th>تخفیف</th>
          <th>قابل پرداخت</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ formatNumber(parseInt(sidebarData.total_amount)) }}</td>
          <td>{{ formatNumber(parseInt(sidebarData.offer_amount)) }}</td>
          <td>{{ formatNumber(parseInt(sidebarData.paying_amount)) }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="col-lg-12 text-center signature">
      <span class="mx-1">آدرس:</span>
      <span>{{ findAttributeOnSiteInfo('address')[0] }} -</span>
      <span v-for="(tel_phone,index) in findAttributeOnSiteInfo('tel_phone')" :key="index" v-if="index===0">
        {{ tel_phone }}
      </span>
    </div>

    <div class="col-lg-12 text-center signature">
      <span class="text-center col-lg-12">ساخت و طراحی توسط

        <m-a class="text-center" href="https://mixitweb.com/">Mixitweb.com</m-a>

      </span>
    </div>
  </div>


</template>

<script>
import tablePaidItems from "./tableIPaidtems.vue";
import {mapGetters} from "vuex";
import router from '@/router';
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {dateConverter} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter'

export default {
  name: "FactorAutoPrint1",
  components: {tablePaidItems},
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getUserOrderPaidItems",
      transactionInfo: "Transaction/getTransaction",
      sidebarData: "Transaction/getFactor",
      loading: "Loading/loadingStatus"
    }),
  },
  methods: {
    print() {
      window.print();
    },
    formatNumber,
    dateConverter,
  },
  async mounted() {
    let orderId = router.currentRoute.params.orderId
    this.$store.dispatch('Transaction/autoPrintShowTransactionDetail', orderId).then(async (res) => {
      const response = await res.data.data;
      await this.$store.commit("ShoppingCart/setSidebarBasketData", response);
      await this.$store.commit("Transaction/setFactor", response);
      await this.$store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
      await this.$store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
      await this.$store.commit("Transaction/setTransaction", response.transaction);
    })
  },
  watch: {
    loading(newValue, oldValue) {
      if (oldValue == true) {
        // add time out to make some time for loadign hide in page.
        setTimeout(() => {
          if (this.$route.query.print === 'on') {
            this.print()
          }
        }, 1_000)
      }
    }
  }
};
</script>

<style>

.custom-pointer-print-icon {
  cursor: pointer;
}

@media print {
  .signature, .signature * {
    font-size: 30px;
  }

  .base-font-size {
    font-size: 50px;
  }

  .print-style {
    font-size: 50px;
    width: 100% !important;
    font-weight: 10;
    color: #000;
    height: auto;
    border-bottom: none !important;
    border-top: 2px solid #000 !important;
    border-left: 2px solid #000 !important;
    border-right: 2px solid #000 !important;
    margin: 10px auto 0 auto;
  }

  .print-style .card {
    border: none !important;
  }

  .print-style tr {
    color: #000;
    border-bottom: 2px solid #000 !important;
    border-top: 2px solid #000 !important;
    border-left: none !important;
    border-right: none !important;
  }

  .table tr, .table th, .table td {
    border-bottom: 2px solid #000 !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
  }


  .list, .print-style table, .print-style thead, .print-style tbody, .signature * {
    color: #000;
  }


}

</style>